import { StaticText as StaticTextType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import Core from './Core'

const StaticText: React.FC<Props<StaticTextType>> = ({ element, update }) => {
  return <Core element={element} update={update} />
}

export default StaticText
